export default "__VITE_ASSET__BDlQjXp1__"